__turbopack_context__.v({
  "searchContainer": "styles-module-scss-module__kd6sUq__searchContainer",
  "searchInput": "styles-module-scss-module__kd6sUq__searchInput",
  "searchLogo": "styles-module-scss-module__kd6sUq__searchLogo",
});
